<template>
  <div style="width: auto" class="py-2">
    <section v-if="!isCollapsed" class="nfe-card pa-2 py-3 pb-2">
      <v-card-text class="d-flex justify-space-between pa-0" style="font-size: 1rem">
        <div v-if="isLongText(unallocatedStop?.nameRecipient || '')">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" v-bind="attrs" v-on="on">
                <span class="font-weight-bold">Destinatário: </span>
                <span :class="['font-weight-regular', { 'subtitle-2': isNameRecipientUppercase }]">
                  {{ truncateText(unallocatedStop?.nameRecipient) }}</span
                >
              </div>
            </template>
            <span>{{ unallocatedStop?.nameRecipient }}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-truncate">
          <span class="font-weight-bold">Destinatário: </span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameRecipientUppercase }]">
            {{ unallocatedStop?.nameRecipient }}</span
          >
        </div>
        <div class="d-flex">
          <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
          <v-icon class="handle-drag" v-show="isDragable" size="24">mdi-drag</v-icon>
        </div>
      </v-card-text>
      <v-card-text class="d-flex pa-0" style="font-size: 1rem">
        <div v-if="isLongText(unallocatedStop?.nameCityRecipient || '')">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" v-bind="attrs" v-on="on">
                <span class="font-weight-bold">Cidade: </span>
                <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">
                  {{ truncateText(unallocatedStop?.nameCityRecipient) }}</span
                >
              </div>
            </template>
            <span>{{ unallocatedStop?.nameCityRecipient }}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-truncate">
          <span class="font-weight-bold">Cidade:</span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">
            {{ unallocatedStop?.nameCityRecipient }}</span
          >
        </div>
      </v-card-text>
      <v-card-text class="d-flex pa-0" style="font-size: 1rem">
        <div class="text-truncate">
          <span class="font-weight-bold">Número de entregas:</span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">
            {{ unallocatedStop?.amountDeliveries }}</span
          >
        </div>
      </v-card-text>

      <v-card-text class="d-flex px-0 py-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular pr-2">{{ formatWeight(unallocatedStop?.weightDeliveries) }}kg</span>
            <span class="font-weight-bold text--secondary">Preço: </span>
            <span class="font-weight-regular">{{ formatPrice(unallocatedStop?.totalPriceNfes) }}</span>
          </v-col>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold text--secondary">N° Parada: </span>

            <span class="font-weight-regular">{{ unallocatedStop?.stopNumber }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <div v-if="unallocatedStop?.error" class="pa-0 w-100" cols="12" md="6">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="text-truncate pr-4" v-bind="attrs" v-on="on">
              <v-icon class="mr-1" size="20" color="red">mdi-alert-circle-outline</v-icon>
              <span class="font-weight-regular caption">{{ unallocatedStop?.error }}</span>
            </div>
          </template>
          <span>{{ unallocatedStop?.error }} <br /></span>
          <span>Transbordos:<br /></span>
          <span v-for="(part, index) in formattedTransshipments" :key="index">
            {{ part }}<span v-if="index < formattedTransshipments.length - 1">,<br /></span>
          </span>
        </v-tooltip>
      </div>
    </section>
    <section v-else class="nfe-card-collapsed pa-0">
      <v-card-text class="w-100 d-flex justify-space-between pa-0 pt-1" style="font-size: 0.95rem">
        <v-col class="pa-0 pl-2 align-self-cente" cols="auto">
          <span class="font-weight-regular text--secondary">N° Parada: </span>
          <span class="font-weight-medium">{{ unallocatedStop?.stopNumber }}</span>
        </v-col>
        <v-col class="d-flex pa-0 pl-3" cols="auto">
          <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
          <v-icon class="handle-drag" v-show="isDragable" size="24">mdi-drag</v-icon>
        </v-col>
      </v-card-text>
      <div v-if="unallocatedStop?.error" class="pa-0 w-100" cols="12" md="6">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="text-truncate pr-4 pl-1" v-bind="attrs" v-on="on">
              <v-icon class="mr-1" size="20" color="red">mdi-alert-circle-outline</v-icon>
              <span class="font-weight-regular caption">{{ unallocatedStop?.error }}</span>
            </div>
          </template>
          <span style="display: inline-block; max-width: 40ch; word-break: break-word">
            {{ unallocatedStop?.error }}
          </span>
          <span v-if="unallocatedStop?.transshipments"> <br />Transbordos:<br /></span>
          <span v-for="(part, index) in formattedTransshipments" :key="index">
            {{ part }}<span v-if="index < formattedTransshipments.length - 1">,<br /></span>
          </span>
        </v-tooltip>
      </div>
    </section>
  </div>
</template>

<script>
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';

export default {
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    unallocatedStop: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Boolean,
      default: false
    },
    isDragable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localSelected: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      }
    },
    isNameRecipientUppercase() {
      return this.unallocatedStop?.nameRecipient === this.unallocatedStop?.nameRecipient.toUpperCase();
    },
    isNameSenderUppercase() {
      return this.unallocatedStop?.nameCityRecipient === this.unallocatedStop?.nameCityRecipient.toUpperCase();
    },
    formattedTransshipments() {
      if (this.unallocatedStop && this.unallocatedStop.transshipments) {
        return this.unallocatedStop.transshipments.split(',').map((part) => part.trim());
      }
      return [];
    }
  },
  methods: {
    copy(str) {
      copyToClipboard(str);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    isLongText(text, limit = 20) {
      return text.length > limit;
    },
    truncateText(text, limit = 20) {
      return text.length > limit ? text.substring(0, limit - 3) + '...' : text;
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    hasMultipleCpfCnpj(cpfCnpj) {
      return cpfCnpj.includes(',');
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.span-nfe {
  font-size: 13px;
}
.nfe-card {
  width: 350px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.nfe-card-collapsed {
  width: 220px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.checkbox-nfe {
  margin-top: 2px;
}
::v-deep .checkbox-nfe .v-input--selection-controls__input {
  margin-right: 0px;
}
</style>
